import { render, staticRenderFns } from "./ChecklistCustoms.vue?vue&type=template&id=522e38d8"
import script from "./ChecklistCustoms.vue?vue&type=script&lang=js"
export * from "./ChecklistCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports